"use client";
import CardReport from "@/app/[locale]/(user-page)/report/components/CardReport";
import { useAddFavoriteLatest } from "@/hooks/Query/useReport";
import { reportFeaturedParams } from "@/models/Params";
import ReportServices from "@/services/main/reportServices";
import { Box } from "@mui/material";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useTranslations } from "next-intl";

interface FeaturedProps {
  categoryId?: string | number;
  queryKey?: string;
  isLoggedIn?: boolean;
  isMobile?: boolean;
  features?: any;
  type: string;
  locale: string;
}

const ReportFeatured = (props: FeaturedProps) => {
  const { categoryId, queryKey, isLoggedIn, isMobile, features, type, locale } =
    props;
  const t = useTranslations("messages");
  const { data: featuredData } = useInfiniteQuery({
    queryKey: [queryKey, categoryId],
    queryFn: async () => {
      const params: reportFeaturedParams = {
        take: 3,
        lang: locale,
        categoryIds: categoryId,
      };
      const result = await ReportServices.getReportFeatured(params);
      return result;
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage?.meta?.cursor,
    select: (data) => {
      return {
        data: (data.pages as any).flatMap((item: any): Report[] => item.data),
        itemCount: (data.pages as any).flatMap(
          (item: any) => item.meta.itemCount
        ),
      };
    },
    refetchOnWindowFocus: false,
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });

  const AddFavorite = useAddFavoriteLatest({
    queryKey: [queryKey, categoryId],
  });

  const handleAddFavorite = (id: number) => {
    AddFavorite.mutate(id);
  };

  return !(featuredData as any)?.data?.length ? null : (
    <>
      {featuredData?.data?.length > 0 ? (
        <div className="gap-4">
          <Box className="py-4">
            <p
              className="text-eerie_black font-semibold text-2xl/6 sm:text-[32px]/[48px] m-0"
              translation-key="home_featured"
            >
              {t("home_featured")}
            </p>
          </Box>
          <Box>
            <Box className="grid grid-cols-12 gap-y-8 md:gap-6">
              {featuredData?.data?.map((item: any, index: any) => (
                <CardReport
                  key={`card-feature-${categoryId}-${item.id}-${index}`}
                  {...item}
                  isLogin={isLoggedIn || false}
                  isMobile={isMobile}
                  handleAddFavorite={handleAddFavorite}
                />
              ))}
            </Box>
          </Box>
        </div>
      ) : null}
    </>
  );
};

export default ReportFeatured;
